export default {
  inserted(el, binding) {
    if (binding.value) {
      window.scrollTo(binding.value.x, binding.value.y);
    }
  }
};